export default __webpack_public_path__ + "static/media/pro-elevate-dmb-banner-3.e4c0f089.jpg";